import { PATHS } from '@src/consts'

export const notAllowedPathNames = {
  bookkeeper: [
    PATHS.SETTINGS_AI_COWORKER,
    PATHS.SETTINGS_EDIT_USER_NAME,
    PATHS.SETTINGS_AI_COWORKER_PERSONALITY,
    PATHS.SETTINGS_AI_COWORKER_EMPLOYEE,
    PATHS.SETTINGS_AI_COWORKER_WORKFLOW,
    PATHS.SETTINGS_SSO,
    PATHS.CARDS_ISSUE,
    PATHS.CARDS_ISSUE_SELECT_TYPE,
    PATHS.CARDS_ISSUE_PHYSICAL,
    PATHS.CARDS_ISSUE_METAL,
  ],
  generalUser: [
    PATHS.SETTINGS_EDIT_USER_NAME,
    PATHS.SETTINGS_MEMO_TEMPLATE,
    PATHS.SETTINGS_ACCOUNTING_DISPLAY,
    PATHS.SETTINGS_COMPANY,
    PATHS.MERCHANTS,
    PATHS.PURCHASE_APPLICATIONS_TEMPLATE_CREATE,
    PATHS.PURCHASE_APPLICATIONS_CREATE_BEFORE_TRANSACTION,
    PATHS.PAYMENTS_CREATE_TRANSFER,
    PATHS.PAYMENTS_LIST,
    PATHS.PAYMENTS_TRANSFERS,
    PATHS.PAYMENTS_TRENDS,
    PATHS.SETTINGS_AI_COWORKER,
    PATHS.SETTINGS_AI_COWORKER_PERSONALITY,
    PATHS.SETTINGS_AI_COWORKER_EMPLOYEE,
    PATHS.SETTINGS_AI_COWORKER_WORKFLOW,
    PATHS.SETTINGS_ACCOUNTING,
    PATHS.SETTINGS_ACCOUNTING_FREEE_REGISTER,
    PATHS.SETTINGS_SLACK_NOTIFICATION,
    PATHS.EVIDENCES,
    PATHS.GUARANTEE_MONEY_DEPOSITS_EXPIRY,
    PATHS.SETTINGS_SLACK_NOTIFICATION_TRANSACTION,
    PATHS.CARDS,
    PATHS.SETTINGS_SSO,
    PATHS.CARDS_ISSUE,
    PATHS.CARDS_ISSUE_SELECT_TYPE,
    PATHS.CARDS_ISSUE_PHYSICAL,
    PATHS.WALLET,
    PATHS.SETTINGS_TEAMS_NOTIFICATION,
    PATHS.SETTINGS_TEAMS_NOTIFICATION_TRANSACTION,
    PATHS.PAYMENTS,
    PATHS.CARDS_ISSUE_METAL,
  ],
  organizationAdmin: [],
  viewer: [
    PATHS.SETTINGS_EMAIL_NOTIFICATION,
    PATHS.SETTINGS_EDIT_USER_NAME,
    PATHS.SETTINGS_ACCOUNTING_DISPLAY,
    PATHS.SETTINGS_COMPANY,
    PATHS.PURCHASE_APPLICATIONS_TEMPLATE_CREATE,
    PATHS.PURCHASE_APPLICATIONS_CREATE_BEFORE_TRANSACTION,
    PATHS.SETTINGS_AI_COWORKER,
    PATHS.SETTINGS_AI_COWORKER_PERSONALITY,
    PATHS.SETTINGS_AI_COWORKER_EMPLOYEE,
    PATHS.SETTINGS_AI_COWORKER_WORKFLOW,
    PATHS.SETTINGS_ACCOUNTING,
    PATHS.SETTINGS_ACCOUNTING_FREEE_REGISTER,
    PATHS.SETTINGS_SLACK_NOTIFICATION,
    PATHS.SETTINGS_SLACK_NOTIFICATION_TRANSACTION,
    PATHS.SETTINGS_SSO,
    PATHS.CARDS_ISSUE,
    PATHS.CARDS_ISSUE_SELECT_TYPE,
    PATHS.CARDS_ISSUE_PHYSICAL,
    PATHS.SETTINGS_TEAMS_NOTIFICATION,
    PATHS.SETTINGS_TEAMS_NOTIFICATION_TRANSACTION,
    PATHS.CARDS_ISSUE_METAL,
  ],
}
